import { render, staticRenderFns } from "./SeguroFianca.vue?vue&type=template&id=5836d9fd&scoped=true&"
import script from "./SeguroFianca.vue?vue&type=script&lang=js&"
export * from "./SeguroFianca.vue?vue&type=script&lang=js&"
import style0 from "./SeguroFianca.vue?vue&type=style&index=0&id=5836d9fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5836d9fd",
  null
  
)

export default component.exports